import React, {useEffect, useState} from 'react';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import AppBar from "./AppBar";
import TeamSession from "./TeamSession"
import LinearProgress from '@material-ui/core/LinearProgress';
import Highlighter from "./Highlighter";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import {cyan, orange} from "@material-ui/core/colors";


export default function Teams(props) {
    const [teamsResponse, setTeamsResponse] = useState(null);
    const [chosenCategories, setChosenCategories] = useState(null);
    const [acquaintancesIds, setAcquaintancesIds] = useState({});
    const [showToast, setShowToast] = React.useState(false);
    const [showRedoToast, setShowRedoToast] = React.useState(false);
    const [showErrorToast, setShowErrorToast] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [showAssignmentsError, setShowAssignmentsError] = React.useState(false);

    const theme = createMuiTheme({
        palette: {
            primary: cyan,
            secondary: orange,
        },
    });

    // login data
    const [user] = useState(null);
    const [authenticated] = useState(() => {
        if (props.location.state) {
            return props.location.state.isAuthenticated;
        }
        // Teamsessions page was opened in server side.
        return null;
    });

    useEffect(() => {
            // if the page wasn't opened by client side and also authenticated
            if (!authenticated) {
                window.location.replace(process.env.REACT_APP_URL);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    const fetchData = async function fetchData() {
        const getTeamsUrl = process.env.REACT_APP_BACKEND_URL + "/sessions/exercises/" + props.location.state.id;
        const res = await fetch(getTeamsUrl,{
            method: "GET",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": true
            }
        });
        if (res.status === 401) {
            window.location.replace(process.env.REACT_APP_URL)
        }
        res
            .json()
            .then(res => {
                setTeamsResponse(res);
                setShowAssignmentsError(res.acquaintances.length !== 0);
            })
    };

    useEffect(() => {
        if (authenticated) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showToast]);

    const highlightPersons = (updatedChosenCategories) => {
        setChosenCategories(updatedChosenCategories);
    };

    const calcNumberOfCandidates = teamsResponse =>
        teamsResponse.classes.map(classData => classData.candidates.length).reduce((a, b) => a + b);

    const calcNumberOfReviewers = teamsResponse =>
        teamsResponse.classes.map(classData => classData.reviewers.length).reduce((a, b) => a + b);

    const highlightAcquaintances = (updatedAcquaintances) => {
        const highlightPersons = {};
        // true for regular acquaintancesIds
        updatedAcquaintances.forEach(person => highlightPersons[person.id] = true);
        setAcquaintancesIds(highlightPersons);
    };


    const callbackShowToast = () => {
        setShowToast(true);
        setAcquaintancesIds(null);
        setTeamsResponse(null);
        fetchData();
    };

    const callbackShowRedoToast = () => {
        setShowRedoToast(true);
        setAcquaintancesIds(null);
        setTeamsResponse(null);
        fetchData();
    };

    const handleCloseOfToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowToast(false);
    };

    const handleCloseOfRedoToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowRedoToast(false);
    };

    const callbackShowErrorToast = (toastErrorMesage) => {
        setErrorMessage(toastErrorMesage);
        setShowErrorToast(true);
    };

    const handleCloseOfErrorToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowErrorToast(false);
    };

    const handleCloseAssignmentsError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowAssignmentsError(false);
    };

    // display an empty page until authentication
    if (!authenticated) {
        return <div></div>;
    }

    if (!teamsResponse) {
        return (
            <ThemeProvider theme={theme}>
                <AppBar isHomePageInput={false} titleData={props.location.state.appBarData}
                        sessionId={props.location.state.id} currentView={"Teams"} authenticated={authenticated}
                        user={user}/>
                <LinearProgress/>
            </ThemeProvider>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <AppBar isHomePageInput={false} titleData={props.location.state.appBarData}
                    sessionId={props.location.state.id} currentView={"Teams"} authenticated={authenticated}
                    user={user} data={teamsResponse} callbackShowRedoToast={callbackShowRedoToast} />
            <Highlighter data={teamsResponse.filters} buttonClickCallback={highlightPersons}
                         chosenCategories={chosenCategories} currentView={"Teams"}
                         numClasses={teamsResponse.classes.length}
                         calcNumberOfCandidates={calcNumberOfCandidates(teamsResponse)}
                         calcNumberOfReviewers={calcNumberOfReviewers(teamsResponse)}/>
            {/*true if there is a reviewer who knows a candidate in the same class*/}
            {showAssignmentsError ? (<Alert severity="error" onClose={handleCloseAssignmentsError}
                                            style={{direction: "rtl"}}>
                <div style={{width: "90vw", paddingRight: "1vw"}}>
                    <AlertTitle style={{direction: "rtl"}}>שגיאה בשיבוץ</AlertTitle>
                    {teamsResponse.acquaintances.map((acquaintancesOfReviewer, aIndex) => {
                        return <div key={aIndex}> בכיתה {acquaintancesOfReviewer.class} המעריכ\ה <b>{acquaintancesOfReviewer.reviewer_name}</b> מכיר\ה
                            {acquaintancesOfReviewer.acquaintances_candidates.map((candidate, index) => {
                                return <span key={index}>  {index === acquaintancesOfReviewer.acquaintances_candidates.length - 1
                                && acquaintancesOfReviewer.acquaintances_candidates.length > 1 ? " ואת " : " את "}
                                    <b>{candidate.candidate_name}</b></span>
                            })}
                        </div>
                    })}
                </div>
            </Alert>) : ""
            }
            <div>
                {
                    teamsResponse.classes.map((classData, i) => {
                        return <TeamSession key={i}
                            inputChosenCategories={chosenCategories} teamData={classData}
                            highlightAcquaintances={highlightAcquaintances} acquaintancesIds={acquaintancesIds}
                            sessionsId={props.location.state.id}
                            callbackShowToast={callbackShowToast}
                            callbackShowErrorToast={callbackShowErrorToast}
                        />
                    })
                }
            </div>
            {/*Success toast*/}
            <Snackbar open={showToast} autoHideDuration={4000} onClose={handleCloseOfToast}>
                <Alert onClose={handleCloseOfToast} severity="success">
                    !העריכה הסתיימה בהצלחה
                </Alert>
            </Snackbar>

            {/*Failure toast*/}
            <Snackbar open={showErrorToast} autoHideDuration={4000} onClose={handleCloseOfErrorToast}>
                <Alert onClose={handleCloseOfErrorToast} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>

            {/*Success toast of redo action*/}
            <Snackbar open={showRedoToast} autoHideDuration={4000} onClose={handleCloseOfRedoToast}>
                <Alert onClose={handleCloseOfRedoToast} severity="success">
                    !שיבוץ מחדש הסתיים בהצלחה
                </Alert>
            </Snackbar>
        </ThemeProvider>
    );
}

